const initialState = () => ({
  isEdit: false,
  waste_form: {
    W_NAME: "",
    W_CARNUMBER: "",
    C_CARNUMBER: "",
    W_DRIVER: "",
    W_CARRIER: "",
    W_DATE_I: new Date(),
    C_DATE: Date(),
    W_TIME_I: null,
    W_TIME_O: null,
    C_TIME: null,
    W_WEIGHT: "",
    CHEMICAL_WEIGHT11:null,
    CHEMICAL_WEIGHT12:null,
    CHEMICAL_WEIGHT13:null,
    CHEMICAL_WEIGHT14:null,
    INFECTIOUS_WEIGHT21:null,
    INFECTIOUS_WEIGHT22:null,
    INFECTIOUS_WEIGHT23:null,
    INFECTIOUS_WEIGHT24:null,
    DANGER_WEIGHT31:null,
    DANGER_WEIGHT32:null,
    TRANSACTION_ID:null,
    NEWCUSTOMER_ID:null,
  },
});

const state = initialState();

const getters = {
  GET_WASTEDOC: (state) => state.waste_form,
  IS_EDIT: (state) => state.isEdit,
};
const mutations = {
  SET_IS_EDIT(state, data) {
    state.isEdit = data;
  },
  SET_ALL_ELEMENT(state, data) {
    state.waste_form = Object.assign({}, data);
  },
  MERGE_ALL_ELEMENT(state, data) {
    let object1 = state.waste_form;
    state.waste_form = Object.assign(object1, data);
  },
  SET_ELEMENT(state, data) {
    state.waste_form[data.key] = data.value;
  },
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  W_reset({ commit }) {
    commit("RESET");
  },
  reset({ commit }) {
    commit("RESET");
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
